"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheSupremeHuntAbilityHandler = exports.TheSupremeHuntActorAbilityFactory = exports.TheSupremeHuntAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class TheSupremeHuntAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TheSupremeHunt;
        this.__typeName = "TheSupremeHunt";
    }
}
exports.TheSupremeHuntAbilityArgs = TheSupremeHuntAbilityArgs;
let TheSupremeHuntActorAbilityFactory = class TheSupremeHuntActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TheSupremeHunt", "Self", 4);
    }
};
TheSupremeHuntActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TheSupremeHunt")
], TheSupremeHuntActorAbilityFactory);
exports.TheSupremeHuntActorAbilityFactory = TheSupremeHuntActorAbilityFactory;
let TheSupremeHuntAbilityHandler = class TheSupremeHuntAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuffs({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effects: [
                {
                    duration: Duration_1.Duration.Turns(4),
                    effect: new __1.LinkedEffectsEffectArgs([
                        new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Power")),
                        new __1.HuntersSupremacyEffectArgs()
                    ], false)
                }
            ],
            onApplied(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet", "behind"), "FireMagicCircle"));
            },
        });
    }
};
TheSupremeHuntAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TheSupremeHunt)
], TheSupremeHuntAbilityHandler);
exports.TheSupremeHuntAbilityHandler = TheSupremeHuntAbilityHandler;
